import css from 'styled-jsx/css';

export const staticStyles = css.global`
  .ContactsFilters {
    margin: 0 0 20px;
    color: #334155;
  }

  .ContactsFilters__buttons {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  .ContactsFilters__saved {
    margin-bottom: 12px;
  }

  .ContactsFilters__saved .ContactsFilters__buttons {
    align-items: flex-end;
    margin-bottom: 8px;
  }

  .ContactsFilters__saved label {
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-size: 13px;
    min-width: 180px;
    max-width: 100%;
  }

  .ContactsFilters__toolbar {
    display: flex;
    flex-wrap: wrap;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: #f8fafc;
    padding: 12px 14px;
    gap: 10px;
    align-items: flex-end;
    row-gap: 12px;
  }

  .ContactsFilters button,
  .ContactsFilters__editor button {
    padding: 8px 12px;
    min-height: 36px;
    background: white;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    color: #334155;
    cursor: pointer;
  }

  .ContactsFilters button:hover,
  .ContactsFilters__editor button:hover {
    border-color: #0aa1e2;
  }

  .ContactsFilters button:disabled {
    opacity: 0.5;
    cursor: default;
  }

  .ContactsFilters button:focus-visible,
  .ContactsFilters__editor button:focus-visible,
  .ContactsFilters__column-button:focus-visible {
    outline: 2px solid #0aa1e2;
    outline-offset: 2px;
  }

  .ContactsFilters input,
  .ContactsFilters select,
  .ContactsFilters__editor input:not([type='checkbox']),
  .ContactsFilters__editor select {
    display: block;
    box-sizing: border-box;
    padding: 8px 10px;
    min-height: 38px;
    width: 100%;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    color: #334155;
    background: white;
  }

  .ContactsFilters select,
  .ContactsFilters__editor select {
    -webkit-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8' fill='none'%3E%3Cpath d='M1 1.5 6 6.5l5-5' stroke='%235b6b7f' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 11px center;
    background-size: 12px 8px;
    padding-right: 32px;
    cursor: pointer;
    background-color: #fff;
  }

  .ContactsFilters__hint {
    line-height: 1.5;
    color: #5b6b7f;
    font-size: 12px;
  }

  .ContactsFilters__editor .ContactsFilters__primary {
    background: #087db5;
    color: white;
    border-color: #087db5;
    font-weight: 500;
  }

  .ContactsFilters__active {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
  }

  .ContactsFilters__chip {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    border-radius: 6px;
    background: #edf6fc;
    border: 1px solid #cce5f5;
    overflow: hidden;
  }

  .ContactsFilters__chip button {
    border: 0;
    background: transparent;
    min-height: 30px;
    padding: 5px 8px;
    text-align: left;
    overflow-wrap: anywhere;
  }

  .ContactsFilters__chip > span {
    padding: 5px 8px;
    overflow-wrap: anywhere;
  }

  .ContactsFilters__chip button:last-child {
    flex-shrink: 0;
  }

  .NewContactsTable .NewBaseTable__head__col-label .ContactsFilters__column {
    display: inline-flex;
    align-items: center;
    gap: 5px;
  }

  .ContactsFilters__column-button {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 28px;
    border-radius: 4px;
    cursor: pointer;
    background: transparent;
    border: 0;
    color: #7a8aa0;
  }

  .ContactsFilters__column-button.is-active {
    background: #087db5;
    color: #fff;
    box-shadow: 0 0 0 2px #cfe6f5;
  }

  .ContactsFilters__editor {
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 0;
    max-width: 100%;
    color: #334155;
    width: 100%;
  }

  .ContactsFilters__editor label {
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-size: 13px;
  }

  .ContactsFilters__editor fieldset {
    border: 0;
    padding: 0;
    min-width: 0;
  }

  .ContactsFilters__editor legend {
    margin-bottom: 6px;
  }

  .ContactsFilters__range {
    display: flex;
    gap: 12px;
  }

  .ContactsFilters__range label {
    flex: 1;
    min-width: 0;
  }

  .ContactsFilters__choices {
    overflow-y: auto;
    margin-top: 8px;
    max-height: 260px;
    padding: 4px 10px;
    border: 1px solid #d8e0ea;
    border-radius: 6px;
    background: #fff;
  }

  .ContactsFilters__choices label {
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    padding: 7px 4px;
    border-radius: 4px;
  }

  .ContactsFilters__choices input[type='checkbox'] {
    -webkit-appearance: auto;
    -moz-appearance: auto;
    appearance: auto;
    box-sizing: border-box;
    flex: 0 0 16px;
    width: 16px;
    height: 16px;
    padding: 0;
    margin: 0 4px 0 0;
    accent-color: #087db5;
    cursor: pointer;
  }

  .ContactsFilters__choices input[type='checkbox']:focus-visible {
    outline: 2px solid #0aa1e2;
    outline-offset: 2px;
  }

  .ContactsFilters__error {
    color: #b91c1c;
    margin-top: 10px;
  }

  @media (max-width: 600px) {
      .ContactsFilters__range {
      flex-direction: column;
    }
    .ContactsFilters__editor {
      width: 100%;
    }
  }

  .ContactsFilters :is(button, input, select, [tabindex]):focus-visible,
  .ContactsFilters__editor :is(button, input, select):focus-visible {
    outline: 2px solid #0aa1e2;
    outline-offset: 2px;
    border-radius: 4px;
  }

  .ContactsFilters select:hover,
  .ContactsFilters__editor select:hover {
    border-color: #0aa1e2;
  }

  .ContactsFilters__editor select:disabled {
    background-image: none;
    background-color: #f1f5f9;
    cursor: not-allowed;
  }

  .ContactsFilters__toolbar > button {
    height: 36px;
    min-height: 36px;
    font-size: 14px;
    white-space: nowrap;
  }

  .ContactsFilters__toolbar > button:first-child {
    background: #087db5;
    border-color: #087db5;
    color: #fff;
    font-weight: 500;
  }

  .ContactsFilters__toolbar > button:first-child:hover {
    background: #0a6e9e;
    border-color: #0a6e9e;
  }

  .ContactsFilters__toolbar > .ContactsFilters__danger {
    color: #b91c1c;
    border-color: #f0c9c9;
    background: #fff;
  }

  .ContactsFilters__toolbar > .ContactsFilters__danger:hover {
    background: #fef2f2;
    border-color: #b91c1c;
  }

  .ContactsFilters__chip > button:first-child {
    cursor: pointer;
    font-size: 13px;
  }

  .ContactsFilters__chip > button:first-child:hover {
    background: #dcecf8;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  .ContactsFilters__chip > button:last-child {
    min-width: 28px;
    min-height: 28px;
    border-left: 1px solid #cce5f5;
    color: #5b6b7f;
    font-size: 15px;
    line-height: 1;
  }

  .ContactsFilters__chip > button:last-child:hover {
    background: #fef2f2;
    color: #b91c1c;
  }

  .ContactsFiltersOverlay.ReactModal__Overlay {
    position: fixed;
    inset: 0;
    z-index: 1100;
  }

  .ContactsFiltersModal.ReactModal__Content {
    box-sizing: border-box;
    inset: auto !important;
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    width: #{'min(520px, calc(100vw - 32px))'} !important;
    max-width: calc(100vw - 32px);
    max-height: #{'min(86vh, 760px)'} !important;
    margin: 0;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    padding: 24px !important;
    border: 0 !important;
    border-radius: 12px !important;
    box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22) !important;
  }

  .ContactsFilters__editor .ContactsFilters__buttons {
    justify-content: flex-end;
    gap: 10px;
    margin-top: 4px;
    padding-top: 16px;
    border-top: 1px solid #e5e9ef;
  }

  .ContactsFilters__editor .ContactsFilters__buttons button {
    min-height: 40px;
    padding: 8px 18px;
  }

  .ContactsFilters__choices label:hover {
    background: #f7f9fb;
  }

  .ContactsFilters__editor fieldset legend {
    font-size: 13px;
    color: #5b6b7f;
  }

  .ContactsFilters__column-button:hover {
    background: #e8eef5;
    color: #334155;
  }

  .ContactsFiltersModal.ReactModal__Content .BasicModal__inner {
    min-width: 0;
    padding: 0;
  }
`;
